define('modules/scroll-animate', [
    'domReady',
    'jquery',
    'underscore',
    'wow',
    'velocity',
    'velocity.ui'
],  function (domReady, $, _) {
    'use strict';

    console.log('%cfile: scroll-animate.js', 'color: #C2ECFF');

    var _this;
    var _defaults = {
        elements: {
            'container': '[data-scroll-animate]',
            'item': '[data-scroll-animate-item]'
        },
        $elements: {},
        animates: {}
    };

    /** constructor */
    function Module(){
        console.log('%ctrace: ScrollAnimate -> constructor', 'color: #ccc');

        _this = this;

        domReady(function () {
            console.log('%ctrace: ScrollAnimate -> constructor -> domReady', 'color: #ccc');

            domElementsUpdates();

            if (_defaults.$elements.container.length <= 0) {
                return false;
            }

            _defaults.$elements.item.css('opacity', 0);

            var wow = new WOW({
                boxClass:     'wow',      // animated element css class (default is wow)
                animateClass: 'animated', // animation css class (default is animated)
                offset:       0,          // distance to the element when triggering the animation (default is 0)
                mobile:       true,       // trigger animations on mobile devices (default is true)
                live:         true,       // act on asynchronously loaded content (default is true)
                callback:     function(el) {
                    var $el = $(el),
                        name = $el.attr('data-scroll-animate');

                    if(!_defaults.animates[name]){
                        return;
                    }

                    console.log('animated ', name);

                    _defaults.animates[name]($el);
                },
                scrollContainer: null // optional scroll container selector, otherwise use window
            });

            wow.init();

            var wowLens = new WOW({
                boxClass:     'js__lens-scroll-animate',      // animated element css class (default is wow)
                animateClass: 'animated', // animation css class (default is animated)
                offset:       100,          // distance to the element when triggering the animation (default is 0)
                mobile:       true,       // trigger animations on mobile devices (default is true)
                live:         true,       // act on asynchronously loaded content (default is true)
                callback:     function(el) {
                    var $el = $(el);

                    $el.removeClass('init');
                },
                scrollContainer: null // optional scroll container selector, otherwise use window
            });

            wowLens.init();
        });
    }

    _defaults.animates = {
        'main-articles': function($el) {
            var $items = $el.find(_defaults.elements.item);

            $items.velocity('stop').velocity('transition.slideUpIn', {
                duration: 1000,
                stagger: 300,
                mobileHA: true,
                display: 'inline-block',
                begin: function(){

                },
                complete: function(){

                }
            });
        },
        'main-promo-blocks': function($el) {
            var $items = $el.find(_defaults.elements.item);

            $items.velocity('stop').velocity('transition.slideUpIn', {
                duration: 1000,
                stagger: 300,
                mobileHA: true,
                begin: function(){

                },
                complete: function(){

                }
            });
        },
        'main-footer-blocks': function($el) {
            var $items = $el.find(_defaults.elements.item);

            $items.velocity('stop').velocity('transition.slideUpIn', {
                duration: 1000,
                stagger: 300,
                mobileHA: true,
                display: 'inline-block',
                begin: function(){

                },
                complete: function(){

                }
            });
        }
    };

    function domElementsUpdates(){
        console.log('%ctrace: ScrollAnimate -> domElementsUpdates', 'color: #ccc');

        _.forEach(_defaults.elements, function(value, key){
            _defaults.$elements[key] = $(value);
        });
    }

    return Module;
});

